import React from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import InputSearchAsync, { ValueProps } from '../inputs/InputSearchAsync';

type ValueType = { label: string; value: string };
type InputValueType = { id: string; values: ValueType[] };

interface FilterInputProps {
  id: string;
  type: 'erp-origem' | 'autocomplete' | 'text' | 'number' | 'date';
  value: ValueProps[] | string | number | null;
  label?: string;
  multiple?: boolean;
  onChange: (newValue: any) => void;
}

export function FilterInputs({ id, type, value, label, onChange }: FilterInputProps) {
  switch (type) {
    case 'erp-origem':
      return (
        <InputSearchAsync
          fullWidth
          multiple
          size="small"
          source="erp-origem"
          id={`input-${id}`}
          onChange={(e: ValueProps[]) => onChange(e)}
          value={value as ValueProps[]}
          label={label ?? 'Origem (+)'}
          sx={{ minWidth: 240, flex: 1 }}
        />
      );

    case 'autocomplete':
      return (
        <Autocomplete
          multiple
          value={value as any}
          onChange={(_event, newValue) => onChange(newValue)}
          size="small"
          filterSelectedOptions
          options={[
            { label: 'Opção 1', value: 'op1' },
            { label: 'Opção 2', value: 'op2' },
          ]} // Simulação de opções
          getOptionLabel={option => option.label}
          renderInput={params => <TextField {...params} variant="outlined" size="small" label="Autocomplete" />}
          renderTags={(_value, getTagProps) =>
            _value?.map((option, index) => (
              <Chip key={option.value} label={option.label} size="small" {...getTagProps({ index })} />
            ))
          }
        />
      );

    case 'text':
      return (
        <TextField
          fullWidth
          size="small"
          id={`input-${id}`}
          label="Texto"
          variant="outlined"
          onChange={e => onChange(e.target.value)}
          value={value as string}
        />
      );

    case 'number':
      return (
        <TextField
          fullWidth
          size="small"
          id={`input-${id}`}
          label="Número"
          type="number"
          variant="outlined"
          onChange={e => onChange(Number(e.target.value))}
          value={value as number}
        />
      );

    case 'date':
      return (
        <TextField
          fullWidth
          size="small"
          id={`input-${id}`}
          label="Data"
          type="date"
          variant="outlined"
          onChange={e => onChange(e.target.value)}
          value={value as string}
          InputLabelProps={{ shrink: true }}
        />
      );

    default:
      return null;
  }
}
